// Centralized Lead Management Mock Data Structure
// This comprehensive data structure includes all possible fields for lead management
// Design your backend tables based on this structure

// ===== LEAD STATUSES (Backend Compatible) =====
// These match the backend FilterDropdownOption values
export const LEAD_STATUSES = {
  PENDING: { 
    id: '1', 
    value: 'Pending', 
    label: 'Pending', 
    color: 'warning',
    bgColor: 'bg-yellow-50 dark:bg-yellow-900/20',
    textColor: 'text-yellow-700 dark:text-yellow-300',
    borderColor: 'border-yellow-200 dark:border-yellow-800',
    dotColor: 'bg-yellow-400',
    icon: '⏳'
  },
  COMPLETED: { 
    id: '2', 
    value: 'Completed', 
    label: 'Completed', 
    color: 'info',
    bgColor: 'bg-blue-50 dark:bg-blue-900/20',
    textColor: 'text-blue-700 dark:text-blue-300',
    borderColor: 'border-blue-200 dark:border-blue-800',
    dotColor: 'bg-blue-400',
    icon: '✅'
  },
  MISSED: { 
    id: '3', 
    value: 'Missed', 
    label: 'Missed', 
    color: 'warning',
    bgColor: 'bg-orange-50 dark:bg-orange-900/20',
    textColor: 'text-orange-700 dark:text-orange-300',
    borderColor: 'border-orange-200 dark:border-orange-800',
    dotColor: 'bg-orange-400',
    icon: '⏰'
  },
  FAILED: { 
    id: '4', 
    value: 'Failed', 
    label: 'Failed', 
    color: 'error',
    bgColor: 'bg-red-50 dark:bg-red-900/20',
    textColor: 'text-red-700 dark:text-red-300',
    borderColor: 'border-red-200 dark:border-red-800',
    dotColor: 'bg-red-400',
    icon: '❌'
  },
  CONTACTED: { 
    id: '5', 
    value: 'Contacted', 
    label: 'Contacted', 
    color: 'success',
    bgColor: 'bg-green-50 dark:bg-green-900/20',
    textColor: 'text-green-700 dark:text-green-300',
    borderColor: 'border-green-200 dark:border-green-800',
    dotColor: 'bg-green-400',
    icon: '📞'
  },
  CLOSED: { 
    id: '6', 
    value: 'Closed', 
    label: 'Closed', 
    color: 'success',
    bgColor: 'bg-emerald-50 dark:bg-emerald-900/20',
    textColor: 'text-emerald-700 dark:text-emerald-300',
    borderColor: 'border-emerald-200 dark:border-emerald-800',
    dotColor: 'bg-emerald-400',
    icon: '🎯'
  },
  LOST: { 
    id: '7', 
    value: 'Lost', 
    label: 'Lost', 
    color: 'error',
    bgColor: 'bg-red-50 dark:bg-red-900/20',
    textColor: 'text-red-700 dark:text-red-300',
    borderColor: 'border-red-200 dark:border-red-800',
    dotColor: 'bg-red-400',
    icon: '💔'
  },
  CANCELED: { 
    id: '8', 
    value: 'Canceled', 
    label: 'Canceled', 
    color: 'neutral',
    bgColor: 'bg-gray-50 dark:bg-gray-900/20',
    textColor: 'text-gray-700 dark:text-gray-300',
    borderColor: 'border-gray-200 dark:border-gray-800',
    dotColor: 'bg-gray-400',
    icon: '🚫'
  },
  JUNK: { 
    id: '9', 
    value: 'Junk', 
    label: 'Junk', 
    color: 'neutral',
    bgColor: 'bg-gray-50 dark:bg-gray-900/20',
    textColor: 'text-gray-700 dark:text-gray-300',
    borderColor: 'border-gray-200 dark:border-gray-800',
    dotColor: 'bg-gray-400',
    icon: '🗑️'
  }
};

// ===== LEAD STAGES =====
export const LEAD_STAGES = {
  AWARENESS: { id: 'awareness', label: 'Awareness', order: 1, color: 'blue' },
  INTEREST: { id: 'interest', label: 'Interest', order: 2, color: 'indigo' },
  CONSIDERATION: { id: 'consideration', label: 'Consideration', order: 3, color: 'purple' },
  INTENT: { id: 'intent', label: 'Intent', order: 4, color: 'pink' },
  EVALUATION: { id: 'evaluation', label: 'Evaluation', order: 5, color: 'orange' },
  PURCHASE: { id: 'purchase', label: 'Purchase', order: 6, color: 'green' }
};

// ===== LEAD SOURCES =====
export const LEAD_SOURCES = {
  GOOGLE_ADS: { id: 'google_ads', label: 'Google Ads', category: 'paid', icon: '🔍' },
  FACEBOOK_ADS: { id: 'facebook_ads', label: 'Facebook Ads', category: 'paid', icon: '📘' },
  LINKEDIN_ADS: { id: 'linkedin_ads', label: 'LinkedIn Ads', category: 'paid', icon: '💼' },
  INSTAGRAM_ADS: { id: 'instagram_ads', label: 'Instagram Ads', category: 'paid', icon: '📸' },
  YOUTUBE_ADS: { id: 'youtube_ads', label: 'YouTube Ads', category: 'paid', icon: '📺' },
  ORGANIC_SEARCH: { id: 'organic_search', label: 'Organic Search', category: 'organic', icon: '🔍' },
  DIRECT_TRAFFIC: { id: 'direct_traffic', label: 'Direct Traffic', category: 'organic', icon: '🌐' },
  REFERRAL: { id: 'referral', label: 'Referral', category: 'organic', icon: '👥' },
  EMAIL_MARKETING: { id: 'email_marketing', label: 'Email Marketing', category: 'organic', icon: '📧' },
  CONTENT_MARKETING: { id: 'content_marketing', label: 'Content Marketing', category: 'organic', icon: '📝' },
  WEBINAR: { id: 'webinar', label: 'Webinar', category: 'organic', icon: '🎥' },
  TRADE_SHOW: { id: 'trade_show', label: 'Trade Show', category: 'offline', icon: '🏢' },
  COLD_CALLING: { id: 'cold_calling', label: 'Cold Calling', category: 'outbound', icon: '📞' },
  COLD_EMAIL: { id: 'cold_email', label: 'Cold Email', category: 'outbound', icon: '✉️' }
};

// ===== LEAD PRIORITIES =====
export const LEAD_PRIORITIES = {
  LOW: { id: 'low', label: 'Low', color: 'gray', score: 1 },
  MEDIUM: { id: 'medium', label: 'Medium', color: 'yellow', score: 2 },
  HIGH: { id: 'high', label: 'High', color: 'orange', score: 3 },
  URGENT: { id: 'urgent', label: 'Urgent', color: 'red', score: 4 },
  HOT: { id: 'hot', label: 'Hot', color: 'red', score: 5 }
};

// ===== LEAD OWNERS/TEAMS =====
export const LEAD_OWNERS = {
  SALES_TEAM_A: { id: 'sales_team_a', label: 'Sales Team A', department: 'sales', members: ['John Doe', 'Sarah Smith', 'Mike Johnson'] },
  SALES_TEAM_B: { id: 'sales_team_b', label: 'Sales Team B', department: 'sales', members: ['Emily Davis', 'David Wilson', 'Lisa Anderson'] },
  MARKETING_TEAM: { id: 'marketing_team', label: 'Marketing Team', department: 'marketing', members: ['Alex Brown', 'Jessica Lee', 'Kevin Zhang'] },
  INSIDE_SALES: { id: 'inside_sales', label: 'Inside Sales', department: 'sales', members: ['Robert Taylor', 'Amanda White', 'Chris Garcia'] },
  ENTERPRISE_SALES: { id: 'enterprise_sales', label: 'Enterprise Sales', department: 'sales', members: ['Mark Thompson', 'Jennifer Lopez', 'Daniel Kim'] },
  CUSTOMER_SUCCESS: { id: 'customer_success', label: 'Customer Success', department: 'support', members: ['Rachel Green', 'Thomas Miller', 'Sophie Chen'] }
};

// ===== COURSES AND PROGRAMS =====
export const PROGRAMS = {
  UG: { id: 'ug', label: 'Undergraduate (UG)', level: 'undergraduate' },
  PG: { id: 'pg', label: 'Postgraduate (PG)', level: 'postgraduate' },
  DIPLOMA: { id: 'diploma', label: 'Diploma', level: 'diploma' },
  CERTIFICATE: { id: 'certificate', label: 'Certificate', level: 'certificate' },
  PROFESSIONAL: { id: 'professional', label: 'Professional', level: 'professional' }
};

export const COURSES = {
  // Undergraduate Courses
  BCA: { id: 'bca', label: 'Bachelor of Computer Application (BCA)', program: 'ug', duration: '3 years', category: 'technology' },
  BTech_CS: { id: 'btech_cs', label: 'B.Tech Computer Science', program: 'ug', duration: '4 years', category: 'engineering' },
  BTech_IT: { id: 'btech_it', label: 'B.Tech Information Technology', program: 'ug', duration: '4 years', category: 'engineering' },
  BBA: { id: 'bba', label: 'Bachelor of Business Administration (BBA)', program: 'ug', duration: '3 years', category: 'business' },
  BCOM: { id: 'bcom', label: 'Bachelor of Commerce (B.Com)', program: 'ug', duration: '3 years', category: 'commerce' },
  
  // Postgraduate Courses
  MCA: { id: 'mca', label: 'Master of Computer Application (MCA)', program: 'pg', duration: '2 years', category: 'technology' },
  MTech_CS: { id: 'mtech_cs', label: 'M.Tech Computer Science', program: 'pg', duration: '2 years', category: 'engineering' },
  MBA: { id: 'mba', label: 'Master of Business Administration (MBA)', program: 'pg', duration: '2 years', category: 'business' },
  MCOM: { id: 'mcom', label: 'Master of Commerce (M.Com)', program: 'pg', duration: '2 years', category: 'commerce' },
  
  // Professional Courses
  DATA_SCIENCE: { id: 'data_science', label: 'Data Science', program: 'professional', duration: '6 months', category: 'technology' },
  WEB_DEVELOPMENT: { id: 'web_development', label: 'Web Development', program: 'professional', duration: '4 months', category: 'technology' },
  DIGITAL_MARKETING: { id: 'digital_marketing', label: 'Digital Marketing', program: 'professional', duration: '3 months', category: 'marketing' },
  CYBERSECURITY: { id: 'cybersecurity', label: 'Cybersecurity', program: 'professional', duration: '6 months', category: 'technology' },
  UI_UX_DESIGN: { id: 'ui_ux_design', label: 'UI/UX Design', program: 'professional', duration: '4 months', category: 'design' }
};

// ===== GEOGRAPHIC DATA =====
export const INDIAN_STATES = {
  ANDAMAN_NICOBAR: { id: 'andaman_nicobar', label: 'Andaman and Nicobar Islands', code: 'AN', zone: 'Islands' },
  ANDHRA_PRADESH: { id: 'andhra_pradesh', label: 'Andhra Pradesh', code: 'AP', zone: 'South' },
  ASSAM: { id: 'assam', label: 'Assam', code: 'AS', zone: 'Northeast' },
  BIHAR: { id: 'bihar', label: 'Bihar', code: 'BR', zone: 'East' },
  CHHATTISGARH: { id: 'chhattisgarh', label: 'Chhattisgarh', code: 'CG', zone: 'Central' },
  DELHI: { id: 'delhi', label: 'Delhi', code: 'DL', zone: 'North' },
  GOA: { id: 'goa', label: 'Goa', code: 'GA', zone: 'West' },
  GUJARAT: { id: 'gujarat', label: 'Gujarat', code: 'GJ', zone: 'West' },
  HARYANA: { id: 'haryana', label: 'Haryana', code: 'HR', zone: 'North' },
  HIMACHAL_PRADESH: { id: 'himachal_pradesh', label: 'Himachal Pradesh', code: 'HP', zone: 'North' },
  JAMMU_KASHMIR: { id: 'jammu_kashmir', label: 'Jammu and Kashmir', code: 'JK', zone: 'North' },
  JHARKHAND: { id: 'jharkhand', label: 'Jharkhand', code: 'JH', zone: 'East' },
  KARNATAKA: { id: 'karnataka', label: 'Karnataka', code: 'KA', zone: 'South' },
  KERALA: { id: 'kerala', label: 'Kerala', code: 'KL', zone: 'South' },
  MADHYA_PRADESH: { id: 'madhya_pradesh', label: 'Madhya Pradesh', code: 'MP', zone: 'Central' },
  MAHARASHTRA: { id: 'maharashtra', label: 'Maharashtra', code: 'MH', zone: 'West' },
  ODISHA: { id: 'odisha', label: 'Odisha', code: 'OD', zone: 'East' },
  PUNJAB: { id: 'punjab', label: 'Punjab', code: 'PB', zone: 'North' },
  RAJASTHAN: { id: 'rajasthan', label: 'Rajasthan', code: 'RJ', zone: 'North' },
  TAMIL_NADU: { id: 'tamil_nadu', label: 'Tamil Nadu', code: 'TN', zone: 'South' },
  TELANGANA: { id: 'telangana', label: 'Telangana', code: 'TS', zone: 'South' },
  UTTAR_PRADESH: { id: 'uttar_pradesh', label: 'Uttar Pradesh', code: 'UP', zone: 'North' },
  UTTARAKHAND: { id: 'uttarakhand', label: 'Uttarakhand', code: 'UK', zone: 'North' },
  WEST_BENGAL: { id: 'west_bengal', label: 'West Bengal', code: 'WB', zone: 'East' }
};

// ===== COMMUNICATION TYPES =====
export const COMMUNICATION_TYPES = {
  CALL: { id: 'call', label: 'Phone Call', icon: '📞', category: 'verbal' },
  EMAIL: { id: 'email', label: 'Email', icon: '📧', category: 'written' },
  SMS: { id: 'sms', label: 'SMS', icon: '💬', category: 'written' },
  WHATSAPP: { id: 'whatsapp', label: 'WhatsApp', icon: '📱', category: 'messaging' },
  MEETING: { id: 'meeting', label: 'Meeting', icon: '🤝', category: 'verbal' },
  VIDEO_CALL: { id: 'video_call', label: 'Video Call', icon: '📹', category: 'verbal' },
  SOCIAL_MEDIA: { id: 'social_media', label: 'Social Media', icon: '📱', category: 'social' },
  WEBINAR: { id: 'webinar', label: 'Webinar', icon: '🎥', category: 'presentation' }
};

// ===== COMPREHENSIVE MOCK LEADS DATA =====
export const mockLeads = [
  {
    id: 1,
    // Basic Information
    name: "Rajesh Kumar Sharma",
    email: "rajesh.sharma@gmail.com",
    mobile: "+91 9876543210",
    alternateMobile: "+91 8765432109",
    
    // Location Details
    state: "Rajasthan",
    district: "Jaipur",
    city: "Jaipur",
    pincode: "302001",
    address: "123 Main Street, Vaishali Nagar",
    
    // Lead Management
    status: 'qualified',
    stage: 'consideration',
    priority: 'high',
    leadScore: 85,
    source: 'google_ads',
    campaign: "Summer 2024 - Digital Marketing Campaign",
    medium: "cpc",
    
    // Assignment & Ownership
    assignedTo: 'sales_team_a',
    createdBy: 'marketing_team',
    lastContactedBy: 'John Doe',
    
    // Academic Interest
    program: 'ug',
    course: 'bca',
    preferredStartDate: "2024-07-15",
    budget: "₹50,000 - ₹75,000",
    
    // Timeline
    registrationDate: "2024-01-15T10:30:45Z",
    lastContactDate: "2024-01-20T14:22:00Z",
    followUpDate: "2024-01-25T10:00:00Z",
    
    // Flags & Status
    isVerified: true,
    isQualified: true,
    isUntouched: false,
    isHot: true,
    
    // Additional Details
    age: 22,
    gender: "Male",
    occupation: "Student",
    experience: "Fresher",
    qualification: "12th Pass",
    
    // Behavioral Data
    websiteVisits: 15,
    pageViews: 45,
    formSubmissions: 2,
    emailOpens: 8,
    emailClicks: 3,
    lastActivity: "2024-01-22T16:30:00Z",
    
    // Custom Fields
    customFields: {
      parentContact: "+91 9876543211",
      parentName: "Suresh Sharma",
      specialRequirements: "Weekend batches preferred",
      referredBy: "Friend - Amit Patel",
      hearAboutUs: "Google Search"
    },
    
    // Tags
    tags: ["Hot Lead", "Quick Response", "Weekend Preference", "Parent Involved"]
  },
  {
    id: 2,
    name: "Priya Singh",
    email: "priya.singh@yahoo.co.in",
    mobile: "+91 8765432109",
    alternateMobile: null,
    
    state: "Uttar Pradesh",
    district: "Lucknow",
    city: "Lucknow",
    pincode: "226001",
    address: "456 Sector 10, Indira Nagar",
    
    status: 'contacted',
    stage: 'interest',
    priority: 'medium',
    leadScore: 65,
    source: 'facebook_ads',
    campaign: "Web Development Bootcamp - Jan 2024",
    medium: "social",
    
    assignedTo: 'sales_team_b',
    createdBy: 'marketing_team',
    lastContactedBy: 'Sarah Smith',
    
    program: 'professional',
    course: 'web_development',
    preferredStartDate: "2024-02-01",
    budget: "₹25,000 - ₹40,000",
    
    registrationDate: "2024-01-14T14:22:33Z",
    lastContactDate: "2024-01-18T11:15:00Z",
    followUpDate: "2024-01-28T14:00:00Z",
    
    isVerified: true,
    isQualified: true,
    isUntouched: false,
    isHot: false,
    
    age: 24,
    gender: "Female",
    occupation: "Working Professional",
    experience: "2 years",
    qualification: "BCA",
    
    websiteVisits: 8,
    pageViews: 24,
    formSubmissions: 1,
    emailOpens: 5,
    emailClicks: 2,
    lastActivity: "2024-01-21T09:45:00Z",
    
    customFields: {
      currentCompany: "TCS",
      currentSalary: "₹4,50,000",
      careerGoal: "Full Stack Developer",
      preferredMode: "Online",
      availableHours: "Evenings & Weekends"
    },
    
    tags: ["Working Professional", "Career Change", "Online Preferred", "TCS Employee"]
  },
  {
    id: 3,
    name: "Amit Patel",
    email: "amit.patel@hotmail.com",
    mobile: "+91 7654321098",
    alternateMobile: "+91 9876543210",
    
    state: "Gujarat",
    district: "Ahmedabad",
    city: "Ahmedabad",
    pincode: "380001",
    address: "789 Satellite Road, Vastrapur",
    
    status: 'new',
    stage: 'awareness',
    priority: 'low',
    leadScore: 35,
    source: 'linkedin_ads',
    campaign: "Data Science Professional Course",
    medium: "social",
    
    assignedTo: 'inside_sales',
    createdBy: 'marketing_team',
    lastContactedBy: null,
    
    program: 'professional',
    course: 'data_science',
    preferredStartDate: "2024-03-01",
    budget: "₹60,000 - ₹80,000",
    
    registrationDate: "2024-01-13T09:15:20Z",
    lastContactDate: null,
    followUpDate: "2024-01-24T10:00:00Z",
    
    isVerified: false,
    isQualified: false,
    isUntouched: true,
    isHot: false,
    
    age: 26,
    gender: "Male",
    occupation: "Software Engineer",
    experience: "3 years",
    qualification: "B.Tech CS",
    
    websiteVisits: 3,
    pageViews: 12,
    formSubmissions: 1,
    emailOpens: 2,
    emailClicks: 1,
    lastActivity: "2024-01-15T12:20:00Z",
    
    customFields: {
      currentRole: "Software Developer",
      technicalSkills: "Python, Java, SQL",
      careerGoal: "Data Scientist",
      learningPreference: "Hands-on Projects",
      timeCommitment: "Part-time"
    },
    
    tags: ["Software Engineer", "Career Transition", "Part-time Learner", "Technical Background"]
  },
  {
    id: 4,
    name: "Sneha Reddy",
    email: "sneha.reddy@gmail.com",
    mobile: "+91 6543210987",
    alternateMobile: null,
    
    state: "Telangana",
    district: "Hyderabad",
    city: "Hyderabad",
    pincode: "500001",
    address: "321 Banjara Hills, Road No. 12",
    
    status: 'proposal',
    stage: 'evaluation',
    priority: 'high',
    leadScore: 90,
    source: 'referral',
    campaign: "Referral Program 2024",
    medium: "referral",
    
    assignedTo: 'enterprise_sales',
    createdBy: 'customer_success',
    lastContactedBy: 'Mark Thompson',
    
    program: 'pg',
    course: 'mba',
    preferredStartDate: "2024-08-01",
    budget: "₹2,00,000 - ₹3,00,000",
    
    registrationDate: "2024-01-12T16:45:12Z",
    lastContactDate: "2024-01-22T10:30:00Z",
    followUpDate: "2024-01-26T15:00:00Z",
    
    isVerified: true,
    isQualified: true,
    isUntouched: false,
    isHot: true,
    
    age: 25,
    gender: "Female",
    occupation: "Business Analyst",
    experience: "3 years",
    qualification: "B.Tech IT",
    
    websiteVisits: 25,
    pageViews: 78,
    formSubmissions: 3,
    emailOpens: 15,
    emailClicks: 8,
    lastActivity: "2024-01-23T14:15:00Z",
    
    customFields: {
      currentCompany: "Deloitte",
      managementExperience: "Team Lead",
      mbaSpecialization: "Finance & Strategy",
      gmatScore: "720",
      careerAspiration: "Management Consultant"
    },
    
    tags: ["High Potential", "Deloitte Employee", "Management Track", "High GMAT Score", "Quick Decision Maker"]
  },
  {
    id: 5,
    name: "Vikram Joshi",
    email: "vikram.joshi@rediffmail.com",
    mobile: "+91 5432109876",
    alternateMobile: "+91 7654321098",
    
    state: "Maharashtra",
    district: "Pune",
    city: "Pune",
    pincode: "411001",
    address: "567 Koregaon Park, Lane 5",
    
    status: 'negotiation',
    stage: 'intent',
    priority: 'urgent',
    leadScore: 95,
    source: 'organic_search',
    campaign: "Cybersecurity Awareness Week",
    medium: "organic",
    
    assignedTo: 'sales_team_a',
    createdBy: 'marketing_team',
    lastContactedBy: 'John Doe',
    
    program: 'professional',
    course: 'cybersecurity',
    preferredStartDate: "2024-02-15",
    budget: "₹70,000 - ₹90,000",
    
    registrationDate: "2024-01-11T11:30:08Z",
    lastContactDate: "2024-01-23T16:45:00Z",
    followUpDate: "2024-01-25T11:00:00Z",
    
    isVerified: true,
    isQualified: true,
    isUntouched: false,
    isHot: true,
    
    age: 29,
    gender: "Male",
    occupation: "IT Manager",
    experience: "7 years",
    qualification: "MCA",
    
    websiteVisits: 30,
    pageViews: 95,
    formSubmissions: 4,
    emailOpens: 20,
    emailClicks: 12,
    lastActivity: "2024-01-24T08:30:00Z",
    
    customFields: {
      currentCompany: "Infosys",
      securityClearance: "Yes",
      teamSize: "15 members",
      urgentNeed: "Compliance requirement",
      decisionMaker: "Yes"
    },
    
    tags: ["Decision Maker", "Urgent Need", "IT Manager", "Large Team", "Compliance Driven"]
  }
];

// ===== ADDITIONAL MOCK DATA =====

// Communication Logs
export const mockCommunications = [
  {
    id: 1,
    leadId: 1,
    type: 'call',
    direction: 'outbound',
    subject: 'Initial consultation call',
    summary: 'Discussed course details and career prospects. Lead is very interested in BCA program.',
    outcome: 'positive',
    duration: '25 minutes',
    scheduledAt: '2024-01-20T14:00:00Z',
    completedAt: '2024-01-20T14:22:00Z',
    conductedBy: 'John Doe',
    nextAction: 'Send course brochure and fee structure',
    rating: 4
  },
  {
    id: 2,
    leadId: 1,
    type: 'email',
    direction: 'outbound',
    subject: 'BCA Course Details & Fee Structure',
    summary: 'Sent comprehensive course information as requested during the call.',
    outcome: 'delivered',
    sentAt: '2024-01-20T15:30:00Z',
    openedAt: '2024-01-20T18:45:00Z',
    clickedAt: '2024-01-20T19:15:00Z',
    conductedBy: 'John Doe',
    attachments: ['bca_brochure.pdf', 'fee_structure.pdf'],
    nextAction: 'Follow up after 3 days'
  }
];

// Notes
export const mockNotes = [
  {
    id: 1,
    leadId: 1,
    title: 'Parent Involvement Discussion',
    content: 'Student mentioned that parents are actively involved in decision making. Father (Suresh Sharma) is particularly interested in placement statistics. Suggested scheduling a call with parents.',
    category: 'important',
    createdBy: 'John Doe',
    createdAt: '2024-01-20T14:30:00Z',
    isPrivate: false,
    tags: ['parent-involvement', 'placement-stats']
  },
  {
    id: 2,
    leadId: 1,
    title: 'Weekend Batch Preference',
    content: 'Lead specifically requested weekend batches due to current part-time job. Need to check availability for weekend slots in BCA program.',
    category: 'requirement',
    createdBy: 'John Doe',
    createdAt: '2024-01-20T14:35:00Z',
    isPrivate: false,
    tags: ['weekend-batch', 'schedule-preference']
  }
];

// Timeline Events
export const mockTimelineEvents = [
  {
    id: 1,
    leadId: 1,
    type: 'form_submission',
    title: 'Lead Registration',
    description: 'Submitted interest form for BCA program through Google Ads campaign',
    timestamp: '2024-01-15T10:30:45Z',
    source: 'google_ads',
    automated: true
  },
  {
    id: 2,
    leadId: 1,
    type: 'assignment',
    title: 'Lead Assignment',
    description: 'Assigned to Sales Team A for follow-up',
    timestamp: '2024-01-15T11:00:00Z',
    assignedBy: 'System',
    assignedTo: 'Sales Team A',
    automated: true
  },
  {
    id: 3,
    leadId: 1,
    type: 'call',
    title: 'First Contact Call',
    description: 'Initial consultation call completed successfully',
    timestamp: '2024-01-20T14:22:00Z',
    conductedBy: 'John Doe',
    outcome: 'positive',
    automated: false
  }
];

// Documents
export const mockDocuments = [
  {
    id: 1,
    leadId: 1,
    name: '12th_marksheet.pdf',
    type: 'academic_document',
    category: 'qualification',
    size: '2.5 MB',
    uploadedAt: '2024-01-21T10:15:00Z',
    uploadedBy: 'Rajesh Kumar Sharma',
    status: 'verified',
    verifiedBy: 'Academic Team',
    verifiedAt: '2024-01-21T14:30:00Z'
  },
  {
    id: 2,
    leadId: 1,
    name: 'identity_proof.pdf',
    type: 'identity_document',
    category: 'verification',
    size: '1.8 MB',
    uploadedAt: '2024-01-21T10:20:00Z',
    uploadedBy: 'Rajesh Kumar Sharma',
    status: 'pending_verification',
    verifiedBy: null,
    verifiedAt: null
  }
];

// Payment Information
export const mockPayments = [
  {
    id: 1,
    leadId: 4, // Sneha Reddy
    type: 'registration_fee',
    amount: 5000,
    currency: 'INR',
    status: 'paid',
    method: 'online',
    transactionId: 'TXN123456789',
    paymentDate: '2024-01-22T15:30:00Z',
    description: 'MBA Program Registration Fee',
    receiptUrl: '/receipts/TXN123456789.pdf'
  },
  {
    id: 2,
    leadId: 5, // Vikram Joshi
    type: 'course_fee',
    amount: 25000,
    currency: 'INR',
    status: 'pending',
    method: 'installment',
    installmentPlan: '3_months',
    description: 'Cybersecurity Course Fee - First Installment',
    dueDate: '2024-02-15T23:59:59Z'
  }
];

// ===== HELPER FUNCTIONS =====

// Get lead by ID
export const getLeadById = (id) => {
  return mockLeads.find(lead => lead.id === parseInt(id));
};

// Get leads by status
export const getLeadsByStatus = (status) => {
  return mockLeads.filter(lead => lead.status === status);
};

// Get leads by stage
export const getLeadsByStage = (stage) => {
  return mockLeads.filter(lead => lead.stage === stage);
};

// Get leads by priority
export const getLeadsByPriority = (priority) => {
  return mockLeads.filter(lead => lead.priority === priority);
};

// Get leads by assigned team
export const getLeadsByTeam = (teamId) => {
  return mockLeads.filter(lead => lead.assignedTo === teamId);
};

// Get leads by source
export const getLeadsBySource = (source) => {
  return mockLeads.filter(lead => lead.source === source);
};

// Get communications for a lead
export const getCommunicationsByLeadId = (leadId) => {
  return mockCommunications.filter(comm => comm.leadId === parseInt(leadId));
};

// Get notes for a lead
export const getNotesByLeadId = (leadId) => {
  return mockNotes.filter(note => note.leadId === parseInt(leadId));
};

// Get timeline events for a lead
export const getTimelineByLeadId = (leadId) => {
  return mockTimelineEvents.filter(event => event.leadId === parseInt(leadId));
};

// Get documents for a lead
export const getDocumentsByLeadId = (leadId) => {
  return mockDocuments.filter(doc => doc.leadId === parseInt(leadId));
};

// Get payments for a lead
export const getPaymentsByLeadId = (leadId) => {
  return mockPayments.filter(payment => payment.leadId === parseInt(leadId));
};

// Filter options for dropdowns
export const getFilterOptions = () => {
  return {
    leadStages: Object.values(LEAD_STAGES),
    leadStatuses: Object.values(LEAD_STATUSES),
    leadOwners: Object.values(LEAD_OWNERS),
    leadSources: Object.values(LEAD_SOURCES),
    leadPriorities: Object.values(LEAD_PRIORITIES),
    programs: Object.values(PROGRAMS),
    courses: Object.values(COURSES),
    states: Object.values(INDIAN_STATES)
  };
};

// Statistics and Analytics
export const getLeadStatistics = () => {
  const total = mockLeads.length;
  const qualified = mockLeads.filter(lead => lead.isQualified).length;
  const hot = mockLeads.filter(lead => lead.isHot).length;
  const untouched = mockLeads.filter(lead => lead.isUntouched).length;
  
  const statusStats = Object.keys(LEAD_STATUSES).map(status => ({
    status,
    count: mockLeads.filter(lead => lead.status === status).length,
    percentage: Math.round((mockLeads.filter(lead => lead.status === status).length / total) * 100)
  }));
  
  const sourceStats = Object.keys(LEAD_SOURCES).map(source => ({
    source,
    count: mockLeads.filter(lead => lead.source === source).length,
    percentage: Math.round((mockLeads.filter(lead => lead.source === source).length / total) * 100)
  }));
  
  return {
    total,
    qualified,
    hot,
    untouched,
    qualificationRate: Math.round((qualified / total) * 100),
    statusStats,
    sourceStats
  };
};
